
import styles from './ModeSwitch.module.css'
import { ToggleButton } from './ToggleButton'
export type Mode = 'sliding' | 'custom'

interface ModeSwitchProps{
    value: Mode
    onValueChange: (event: any) => void
}

export const ModeSwitch = (props: ModeSwitchProps) => {
    const {
        value,
        onValueChange
    } = props

    const handleToggleButtonClick = (event: Mode) => {
        onValueChange?.(event)
    }

    const handleIsActive = (mode: Mode): boolean => {
        return (value === mode)
    }

    return (
        <div className={styles.ModeSwitch}>
            <ToggleButton 
                active={handleIsActive(`sliding`)}
                caption={'Sliding'}
                value={'sliding'}
                onClick={handleToggleButtonClick}
            />
            <ToggleButton 
                active={handleIsActive(`custom`)}
                caption={'Custom'}
                value={'custom'}
                onClick={handleToggleButtonClick}
            />
        </div>
    )
}